import React, { Component } from "react";

import PropTypes from "prop-types";
import { Img } from "arv-reactcomponents";
import Anchor from "../Anchor";
import { ROUTE_PATHS, MyBag } from "npmlinks-constants";
import Event from "../../analytics/eventFactory";
import Analytics from "../../analytics";

class MybagEmptyState extends Component {
  constructor() {
    super();
    this.onFavClick = this.onFavClick.bind(this);
    this.onShopNowClick = this.onShopNowClick.bind(this);
  }
  onFavClick(event) {
    Analytics.trackEvent({
      action: Event.action.ADD_FROM_FAV_CLICK,
      category: Event.category.MYBAG,
    });
    this.props.onFavClick(event);
  }

  onShopNowClick(event) {
    Analytics.trackEvent({
      action: Event.action.CONTINUE_SHOPPING,
      category: Event.category.MYBAG,
    });
    this.props.onShopNowClick(event);
  }

  render() {
    return (
      <div className="nw-mybagemptystate">
        <div className="nw-mybagemptystate-empty-image">
          <Img
            src={MyBag.IMAGES.EMPTY_BAG_URL}
            className="nw-mybagemptystate-image"
          />
        </div>
        <h2 className="nw-mybagemptystate-msg">
          {MyBag.MYBAGPAGE.MYBAG_EMPTY_MSG}
        </h2>
        <div className="nw-mybagemptystate-actions">
          <Anchor.component
            className="nw-mybagemptystate-shopnow"
            href={ROUTE_PATHS.LISTING}
            to={ROUTE_PATHS.LISTING}
            target="_self"
            onClick={this.onShopNowClick}
          >
            {MyBag.MYBAGPAGE.SHOPNOW_BUTTON}
          </Anchor.component>
        </div>
        <div className="nw-mybagemptystate-fav-link">
          <Anchor.component
            className="nw-mybagemptystate-fav-link-tag"
            onClick={this.onFavClick}
            href={ROUTE_PATHS.SHORTLISTS}
            to={ROUTE_PATHS.SHORTLISTS}
            target="_self"
          >
            {MyBag.MYBAGPAGE.ADDITEMS_CTA}
          </Anchor.component>
        </div>
      </div>
    );
  }
}

MybagEmptyState.propTypes = {
  onFavClick: PropTypes.func.isRequired,
  onShopNowClick: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: MybagEmptyState,
  component: MybagEmptyState,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MybagEmptyState/index.js